<!-- /* [NT-PF-READ-P-POP] 프로필보기(개인) */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="handleToggleModal"
      title="프로필 보기"
    >
      <div class="popupViewProfile" style="padding-bottom: 60px;">
        <div class="popupViewProfileCardImage">
          <figure class="networkSearchItemImage">
            <img src="/images/manager/matching/demo1.png" alt="미국 국기" />
          </figure>
          <div class="popupViewProfileCardImageText">
            <h3 class="popupViewProfileCardImageTitle" style="color: #502423;">
              이 순 신 <span class="personal-chip-green">학생</span>
            </h3>
            <h5 class="popupViewProfileCardImageDesc">032-222-3333</h5>
            <h5 class="popupViewProfileCardImageEmail">asdfsadf@naver.com</h5>
          </div>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">회원 정보</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">아이디</td>
                <td>heros1432</td>
              </tr>
              <tr>
                <td class="firstTd">생년월일</td>
                <td>1984. 02. 06</td>
              </tr>
              <tr>
                <td class="firstTd">구분</td>
                <td>학생</td>
              </tr>
              <tr>
                <td class="firstTd">지역</td>
                <td>대전시 유성구</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h6 class="popupViewProfileHeadline">학력</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">최종학력</td>
                <td>대학교(4년제)</td>
              </tr>
              <tr>
                <td class="firstTd">최종학교명</td>
                <td>대한과학기술대학교</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h6 class="popupViewProfileHeadline">경력 정보</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">
                  2012. 02. 05 <br />
                  ~ 2022. 01. 01
                </td>
                <td>대한공구상사</td>
              </tr>
              <tr>
                <td class="firstTd">2023. 02. 06 ~ 현재</td>
                <td>유성의료기기</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">자기소개</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">나의 소개</td>
                <td>
                  위하여서, 거선의 사라지지 너의 우리 아니한 듣는다. 오아이스도
                  품었기 곧 봄바람이다. 튼튼하며, 돋고, 없으면 맺어, 구하지 가는
                  천고에 끓는 설산에서 아니다. 내는 붙잡아 있는 곳으로 같으며,
                  끝에 광야에서 가지에 같은 황금시대다. 하여도 우리 것은 그들을
                  남는 주며, 끓는다.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">매치메이킹 희망분야</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">1</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">2</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">3</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">4</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">매치메이킹 희망활동</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">1</td>
                <td class="firstTd">희망 분야</td>
                <td>마케팅</td>
              </tr>
              <tr>
                <td class="firstTd">세부 내용</td>
                <td>홍보하는 방법과 채널을 추천받고 싶습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">2</td>
                <td class="firstTd">희망 분야</td>
                <td>마케팅</td>
              </tr>
              <tr>
                <td class="firstTd">세부 내용</td>
                <td>홍보하는 방법과 채널을 추천받고 싶습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <template #footer>
        <div style="display: flex; align-items: center; gap: 1rem;">
          <MainButton
            btnText="네트워킹 신청 하기"
            width="191px"
            customHeight="53px"
            fontSize="2rem"
            @click="handleOk"
          />
          <button
            style="border: 1px solid #989898; background-color: #fff; height: 53px; width: 191px;  font-size: 2rem;"
            @click="handleToggleModal"
          >
            닫기
          </button>
        </div>
      </template>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";

export default {
  name: "PopupViewProfilePersonal",
  components: { BasicModal, MainButton },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
    handleOk: Function,
  },
  data() {
    return {};
  },
  methods: {
    // onClickSubmitForm() { }
  },
};
</script>

<style lang="scss" scoped></style>
